import {TASK_AUTOMATION_DAYS, TASK_AUTOMATION_TRIGGERS} from "@/helpers/constants";
import {format} from 'date-fns';
import { $t } from "@/i18n";
import {parseSysDate} from "@/plugins/formatting";

export const getDaysText = (emailAutomation) => {
    const daysData = TASK_AUTOMATION_DAYS().find(x => x.days === emailAutomation.days)
    return daysData ? daysData.text : null
}

export const getTriggerText = (emailAutomation) => {
    const triggerData = TASK_AUTOMATION_TRIGGERS().find(x => x.type === emailAutomation.trigger)
    return triggerData ? triggerData.text : null
}

export const getDateText = (emailAutomation, personLocale) => {
    if (!emailAutomation.run_at) {
        return null
    }

    const runAt = parseSysDate(emailAutomation.run_at)

    const monthName = format(runAt, 'MMM', { locale: personLocale });
    const monthNameTranslated = $t(monthName)

    const day = runAt.getDate()

    const formatted = day + ' ' + monthNameTranslated

    return formatted
}

const isEmailAutomationToBeSentImmediately = (emailAutomation) => {
    return !emailAutomation.trigger || emailAutomation.trigger === ""
}

export default {
    getDaysText,
    getTriggerText,
    isEmailAutomationToBeSentImmediately,
    getDateText
}